import { type FC, type ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { FormattedHTMLMessage } from "~/nvent-web/components/FormattedHTMLMessage/FormattedHTMLMessage";
import styles from "./GetStarted.module.scss";

type Step = {
  number: number;
  title: ReactNode;
  subSteps: ReactNode;
};

const steps: Step[] = [
  {
    number: 1,
    title: <FormattedMessage id="certifiedPage.getStarted.step1.title" />,
    subSteps: (
      <FormattedHTMLMessage
        id="certifiedPage.getStarted.step1.subSteps"
        Element="ul"
      />
    ),
  },
  {
    number: 2,
    title: <FormattedMessage id="certifiedPage.getStarted.step2.title" />,
    subSteps: (
      <FormattedHTMLMessage
        id="certifiedPage.getStarted.step2.subSteps"
        Element="ul"
      />
    ),
  },
  {
    number: 3,
    title: <FormattedMessage id="certifiedPage.getStarted.step3.title" />,
    subSteps: (
      <FormattedHTMLMessage
        id="certifiedPage.getStarted.step3.subSteps"
        Element="ul"
      />
    ),
  },
];

export const GetStarted: FC = () => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        <FormattedMessage id="certifiedPage.getStarted.title" />
      </h3>
      <ul className={styles.steps}>
        {steps.map((step) => (
          <GetStartedStep key={step.number} step={step} />
        ))}
      </ul>
    </div>
  );
};

const GetStartedStep = ({ step }: { step: Step }) => (
  <li className={styles.step}>
    <article>
      <span className={styles.stepNumber}>{step.number}</span>
      <h2 className={styles.stepTitle}>{step.title}</h2>
      {step.subSteps}
    </article>
  </li>
);
